// @flow

/*
 *  Copyright 2017 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */

import React, {Component} from 'react';
import EmailMeLinkScss from './EmailMeLink.scss';
import Email from '@react/react-spectrum/Icon/Email';
import Button from '@react/react-spectrum/Button';
import Close from '@react/react-spectrum/Icon/Close';
import uuid from 'uuid';
import DownloadUtil from '../../../utils/DownloadUtil';

type Props = {
	appId: string,
	downloadURL: ?string,
	process: ?string,
	productName: string,
	formatMessage: Function,
	closePDP: Function,
	onAppDetailEvent: Function,
	closeDialog: Function,
	productIconUrl: string
};

export default class EmailMeLink extends Component <Props> {
	renderEmailButton() {
		// appId is the product id of the app that is used in url
		const guid = uuid.v4();
		const downloadUrl = DownloadUtil.getEmailMeLinkDownloadUrl(
			this.props.appId === 'creative-cloud',
			this.props.process,
			this.props.downloadURL,
			guid,
			this.props.appId
		);
		const buttonText = this.props.formatMessage({id: 'apps.email.buttontitle'});
		const emailHref = DownloadUtil.getEmailMeLinkHref(
			this.props.appId === 'creative-cloud',
			this.props.productName,
			this.props.appId,
			this.props.process,
			this.props.downloadURL,
			guid,
			this.props.formatMessage
		);
		return (<Button element='a' href={emailHref}
			variant='cta' className={`${EmailMeLinkScss.download_email_button} tileButton`}
			onClick={() => {
				this.props.onAppDetailEvent('click', 'send-link', downloadUrl, guid);this.props.closeDialog();
			}} label={buttonText}>
		</Button>);
	}

	render() {
		const EmailMeLinkHeading = this.props.appId === 'creative-cloud' ? this.props.formatMessage({id: 'apps.creativeCloud.displayName'}) : this.props.productName;
		const productIconUrl = this.props.productIconUrl;
		return (
			<div className={EmailMeLinkScss.emailMeLink}>
				<div className={EmailMeLinkScss.header}>
					<h2>{EmailMeLinkHeading}</h2>
					<div className={EmailMeLinkScss.closeContainer}>
						<Close className={EmailMeLinkScss.closeIcon} size='S'
							onClick={() => {
								this.props.onAppDetailEvent('click', 'close');this.props.closeDialog();
							}}
						/>
					</div>
				</div>

				<div className={EmailMeLinkScss.download_email_container_parent}>
					<div className={EmailMeLinkScss.download_email_header_container}>
						<img className={EmailMeLinkScss.download_app_icon} alt={EmailMeLinkHeading} title={EmailMeLinkHeading} src={productIconUrl}/>
						&rarr;
						<Email className={EmailMeLinkScss.download_email_icon} />
						<div className={EmailMeLinkScss.download_email_subtitle}>
							{this.props.formatMessage({id: 'apps.email.subtitle'}, {appname: EmailMeLinkHeading})}
						</div>
						{this.renderEmailButton()}
					</div>
				</div>
			</div>
		);
	}
}
